import { get } from 'lodash';
export function getBottomSpacerSection({ css }) {
    const bodyBottomPadding = parseInt(get(css, 'so-global-body.paddingBottom'), 10) || 0;
    return {
        height: bodyBottomPadding,
        cssClass: '',
    };
}
//# sourceMappingURL=get-bottom-spacer-section.js.map